export default __webpack_public_path__ + "static/media/(16).6147c472.jpeg";